import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthShell } from '../components/AuthShell';
import { Field } from '../components/ui';
import { api } from '../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell
      title="Reset password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={
        <Link to="/login" className="font-medium text-grove underline">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <p className="rounded border border-success/30 bg-success/5 px-4 py-3 text-sm text-body">
          If an account exists for <strong>{email}</strong>, a reset link is on its way. Check your
          inbox (and in development, the server console).
        </p>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <Field label="Email" htmlFor="email">
            <input
              id="email"
              type="email"
              required
              className="input"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <button type="submit" className="btn-primary btn-lg w-full" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
